/* BeanBurds app download prompt — paired with sections/bb-app-promo.liquid.
   Phones/tablets get a bottom sheet (or corner card on wide screens) with a store button;
   desktop computers get the corner card with a QR code. All settings arrive as data-* on [data-bb-app]. */
(function () {
  'use strict';

  var SNOOZE_KEY = 'bbAppPromo';
  var PAGEVIEW_KEY = 'bbAppPV';
  var BANNER_KEY = 'bbAppBanner';

  function store(key, value, session) {
    try {
      var s = session ? sessionStorage : localStorage;
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key);
      else s.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function detectOs() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
    if (/Android/i.test(ua)) return 'android';
    return 'desktop';
  }

  // Safari on iPhone/iPad (including Safari's in-app view) draws Apple's own App Store banner
  // from the apple-itunes-app meta tag. Chrome, Firefox and the Instagram/Facebook/TikTok
  // browsers never show it, so they keep the sheet.
  function nativeBannerBrowser() {
    var ua = navigator.userAgent || '';
    if (detectOs() !== 'ios') return false;
    if (!/Safari\//.test(ua) || !/Version\//.test(ua)) return false;
    return !/CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|GSA\/|DuckDuckGo|Brave|YaBrowser|FBAN|FBAV|Instagram|Snapchat|TikTok|Bytedance|musical_ly|Line\/|Twitter|WhatsApp|LinkedIn|Pinterest|Telegram/i.test(ua);
  }

  // GA4 via window.gtag, the same path bb-coffee.js uses (bb_circle_tap, bb_load_more). If gtag
  // isn't on the page, the event goes to the GTM dataLayer instead so a GTM tag can pick it up.
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        var payload = { event: name };
        for (var k in params) payload[k] = params[k];
        (window.dataLayer = window.dataLayer || []).push(payload);
      }
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.dataset.bbAppReady) return;
    root.dataset.bbAppReady = '1';

    var d = root.dataset;
    var os = detectOs();
    var mode = os === 'desktop' ? 'scan' : 'install';
    var params = new URLSearchParams(location.search);
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var storeLinks = { ios: d.ios, android: d.android };

    // App Store Connect campaign link: with the provider token (pt) set, each App Store link carries
    // a campaign token (ct) naming where the tap came from, so App Analytics counts installs per source.
    function withCampaign(url, ct) {
      if (!d.pt || !url || url.indexOf('apps.apple.com') < 0 || /[?&]ct=/.test(url)) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'pt=' + encodeURIComponent(d.pt) + '&ct=' + ct + '&mt=8';
    }

    // QR codes point at /?bb_app=get — a phone that lands here goes straight to its store.
    if (params.get('bb_app') === 'get' && storeLinks[os]) {
      var target = os === 'ios' ? withCampaign(storeLinks.ios, 'bb-web-qr') : storeLinks[os];
      var gone = false;
      var go = function () {
        if (gone) return;
        gone = true;
        location.replace(target);
      };
      track('bb_app_qr_scan', { device_os: os, event_callback: go, event_timeout: 800 });
      setTimeout(go, 900);
      return;
    }

    var panel = root.querySelector('.bb-app__panel');
    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var isOpen = false;
    var lastFocus = null;
    var qrDrawn = false;

    root.setAttribute('data-mode', mode);
    root.setAttribute('data-os', os);

    var cta = root.querySelector('[data-bb-app-get]');
    if (cta) cta.href = os === 'ios' ? withCampaign(storeLinks.ios, 'bb-web-prompt') : storeLinks[os] || '#';
    var iosStoreLink = root.querySelector('[data-bb-app-store="ios"]');
    if (iosStoreLink) iosStoreLink.href = withCampaign(storeLinks.ios, 'bb-web-desktop');
    var meta = root.querySelector('[data-bb-app-meta]');
    var metaText = os === 'ios' ? d.metaIos : os === 'android' ? d.metaAndroid : '';
    if (meta && metaText) meta.textContent = metaText;

    function isModal() {
      return !desktopQuery.matches;
    }

    function snoozed() {
      var until = parseInt(store(SNOOZE_KEY), 10);
      return until > Date.now();
    }

    function snooze(days) {
      if (designMode || !days) return;
      store(SNOOZE_KEY, String(Date.now() + days * 864e5));
    }

    // Drawers and quizzes often stay in the page while closed (aria-hidden, slid off-screen,
    // or faded out), so "has a box" is not enough to call them open.
    function showing(el) {
      if (el.getAttribute('aria-hidden') === 'true') return false;
      if (el.checkVisibility && !el.checkVisibility({ visibilityProperty: true, opacityProperty: true })) return false;
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) return false;
      if (r.bottom <= 0 || r.right <= 0 || r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.opacity !== '0';
    }

    // Another dialog (cart drawer, search, a newsletter pop-up) or a focused field means "not now".
    function busy() {
      var active = document.activeElement;
      if (active && active.matches && active.matches('input, textarea, select, [contenteditable="true"]')) return true;
      var others = document.querySelectorAll('dialog[open], [aria-modal="true"]');
      for (var i = 0; i < others.length; i++) {
        if (!root.contains(others[i]) && showing(others[i])) return true;
      }
      return false;
    }

    function tryOpen(attempt) {
      if (busy() && attempt < 6) {
        setTimeout(function () { tryOpen(attempt + 1); }, 4000);
        return;
      }
      if (!busy()) open('auto');
    }

    // Shopify minifies theme JS and turns a dynamic import() in a classic script into require(),
    // so the QR module (an ES module) is pulled in through a tiny module script instead.
    function loadModule(src, name) {
      return new Promise(function (resolve, reject) {
        var cb = 'bbAppMod' + Math.random().toString(36).slice(2);
        var done = false;
        var script = document.createElement('script');
        var timer = setTimeout(function () { finish(new Error('timed out loading ' + src)); }, 10000);
        function finish(err, value) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          try { delete window[cb]; } catch (e) { window[cb] = undefined; }
          if (script.parentNode) script.parentNode.removeChild(script);
          if (err) reject(err);
          else resolve(value);
        }
        window[cb] = function (value) { finish(null, value); };
        script.type = 'module';
        script.textContent = 'import { ' + name + ' } from ' + JSON.stringify(src) + '; var f = window[' + JSON.stringify(cb) + ']; if (f) f(' + name + ');';
        script.onerror = function () { finish(new Error('could not load ' + src)); };
        document.head.appendChild(script);
      });
    }

    function drawQr() {
      if (qrDrawn || !d.qrSrc || !d.qr) return;
      var box = root.querySelector('[data-bb-app-qr]');
      if (!box) return;
      qrDrawn = true;
      // asset_url is protocol-relative (//shop/cdn/...); give the loader a full URL.
      var src = d.qrSrc;
      try { src = new URL(d.qrSrc, location.href).href; } catch (e) {}
      loadModule(src, 'QRCode')
        .then(function (QRCode) {
          new QRCode(box, {
            text: d.qr,
            width: 112,
            height: 112,
            colorDark: '#123B31',
            colorLight: '#ffffff',
            correctLevel: 0,
            useSVG: true,
            alt: '',
          });
        })
        .catch(function (err) {
          // No code to scan: drop the "scan" copy and leave the store link.
          box.hidden = true;
          var copy = root.querySelectorAll('.bb-app__scan-copy strong, .bb-app__scan-copy p');
          for (var i = 0; i < copy.length; i++) copy[i].style.display = 'none';
          if (window.console) console.warn('bb-app: QR code unavailable: ' + ((err && err.message) || err));
        });
    }

    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
        return el.getClientRects().length > 0;
      });
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        var active = document.activeElement;
        if (isModal() || !active || active === document.body || panel.contains(active)) close('esc');
        return;
      }
      if (e.key !== 'Tab' || !isModal()) return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function syncModal() {
      var modal = isModal();
      panel.setAttribute('aria-modal', modal ? 'true' : 'false');
      document.documentElement.classList.toggle('bb-app-lock', isOpen && modal);
      return modal;
    }
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', function () { if (isOpen) syncModal(); });

    function open(reason) {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      var modal = syncModal();
      if (mode === 'scan') drawQr();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
      });
      if (modal) {
        setTimeout(function () {
          panel.focus({ preventScroll: true });
        }, 60);
      }
      document.addEventListener('keydown', onKey);
      if (reason !== 'editor') track('bb_app_prompt_view', { device_os: os, trigger: reason });
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      var hadFocus = panel.contains(document.activeElement);
      root.classList.remove('is-open');
      document.documentElement.classList.remove('bb-app-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        if (!isOpen) root.hidden = true;
      }, 450);
      if (hadFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      // 'get' was already snoozed on click, before the browser left for the store.
      if (reason === 'editor' || reason === 'get') return;
      snooze(parseInt(d.snooze, 10));
      track('bb_app_prompt_dismiss', { device_os: os, method: reason });
    }

    root.addEventListener('click', function (e) {
      var target = e.target.closest('[data-bb-app-close], [data-bb-app-get], [data-bb-app-store]');
      if (!target) return;
      if (target.hasAttribute('data-bb-app-close')) {
        close(target.getAttribute('data-bb-app-close') || 'close');
        return;
      }
      snooze(parseInt(d.snoozeGet, 10));
      track('bb_app_prompt_click', {
        device_os: os,
        store: target.getAttribute('data-bb-app-store') || os,
        placement: target.hasAttribute('data-bb-app-get') ? 'button' : 'store_link',
      });
      close('get');
    });

    // Coming back from the store with the browser's Back button restores this page from cache.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && isOpen && snoozed()) close('editor');
    });

    // Swipe the sheet down to dismiss (phones only, from the header area).
    var startY = null;
    var dragY = 0;
    panel.addEventListener('pointerdown', function (e) {
      if (!isModal() || e.pointerType === 'mouse' || !e.target.closest('.bb-app__drag') || e.target.closest('a, button')) return;
      startY = e.clientY;
      dragY = 0;
      panel.style.transition = 'none';
      try { panel.setPointerCapture(e.pointerId); } catch (err) {}
    });
    panel.addEventListener('pointermove', function (e) {
      if (startY === null) return;
      dragY = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dragY + 'px)';
    });
    function endDrag() {
      if (startY === null) return;
      startY = null;
      panel.style.transition = '';
      panel.style.transform = '';
      if (dragY > 90) close('swipe');
    }
    panel.addEventListener('pointerup', endDrag);
    panel.addEventListener('pointercancel', endDrag);

    root.bbAppOpen = open;
    root.bbAppClose = close;

    // ?app_promo=1 shows it now (for testing); ?app_promo=reset forgets a previous dismissal.
    var force = params.get('app_promo');
    if (force === 'reset') store(SNOOZE_KEY, null);

    var pageviews = (parseInt(store(PAGEVIEW_KEY, undefined, true), 10) || 0) + 1;
    store(PAGEVIEW_KEY, String(pageviews), true);

    // A phone with no store link never sees it, even when forced (iPhone-only launch).
    if (mode === 'install' && !storeLinks[os]) return;

    if (force === '1') {
      setTimeout(function () { open('forced'); }, 400);
      return;
    }

    var wanted = mode === 'install' ? d.mobile !== 'false' : d.desktop !== 'false';
    var inApp = d.uaToken && (navigator.userAgent || '').indexOf(d.uaToken) > -1;
    var standalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
    if (designMode || !wanted || inApp || standalone) return;

    // iPhone Safari: Apple's banner does the asking. Count the visit once per session so the
    // App Store Connect "web referrer" installs have a denominator in GA4.
    if (mode === 'install' && d.safariNative !== 'false' && nativeBannerBrowser()) {
      if (!store(BANNER_KEY, undefined, true)) {
        store(BANNER_KEY, '1', true);
        track('bb_app_banner_eligible', { device_os: os });
      }
      return;
    }

    if (snoozed() || pageviews < (parseInt(d.pageviews, 10) || 1)) return;

    // Trigger on whichever comes first: time on page, or scroll depth.
    var fired = false;
    var delay = Math.max(0, parseFloat(d.delay) || 0) * 1000;
    var depth = parseFloat(d.scroll) || 0;
    var timer;
    function fire() {
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      tryOpen(0);
    }
    function onScroll() {
      var room = document.documentElement.scrollHeight - window.innerHeight;
      if (room > 0 && (window.scrollY / room) * 100 >= depth) fire();
    }
    timer = setTimeout(fire, delay);
    if (depth > 0) window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-bb-app]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  initAll();

  // Theme editor: re-init after a settings change, show while the section is selected.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    var root = e.target.querySelector('[data-bb-app]');
    if (root && root.bbAppOpen) root.bbAppOpen('editor');
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-bb-app]');
    if (root && root.bbAppOpen) root.bbAppOpen('editor');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target.querySelector('[data-bb-app]');
    if (root && root.bbAppClose) root.bbAppClose('editor');
  });
})();
